import { gql } from "apollo-boost";

export const GET_DAILY_CLOSINGS = gql`
  query getDailyClosings(
    $where: DailyClosingSummaryWhereInput
    $relations: [String]
  ) {
    getDailyClosings(where: $where, relations: $relations) {
      id
      date
      statusId
      totalSales
      insuredCoverage
      consultoryFee
      closeDate
      selected
      medicalStaffId
      branchOfficeId
      user {
        id
        firstName
        lastName
        username
      }
      status {
        id
        name
      }
    }
  }
`;

export const UPDATE_CONSULTORY_MONTHLY_CLOSURE = gql`
  mutation updateConsultoryMonthlyClosure(
    $data: UpdateConsultoryMonthlyClosureInput!
  ) {
    updateConsultoryMonthlyClosure(data: $data) {
      id
      statusId
      month
      year
      date
      processedDate
      fiscalSummary {
        insuredFAC {
          insurerName
          date
          ncf
          value
        }
        copayB02 {
          voucherName
          date
          ncf
          value
        }
        ncfInvoices {
          clientName
          date
          ncf
          value
        }
      }
      status {
        id
        name
      }
    }
  }
`;

